import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetEnabledDeliveryDatesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "enabled_dates": [
                    "05-06-2024",
                    "07-06-2024",
                    "12-06-2024",
                    "14-06-2024"
                ],
                "enabled_dates_with_orders": [
                    "05-06-2024",
                    "14-06-2024"
                ],
            },
            errors: []
        }
    }

    enabledDates() {
        return this.content().enabled_dates.map(date => {
            const [day, month, year] = date.split('-');
            return new Date(year, month - 1, day);
        });
    }

    enabledDatesWithOrders() {
        return this.content().enabled_dates_with_orders.map(date => {
            const [day, month, year] = date.split('-');
            return new Date(year, month - 1, day);
        });
    }

}